import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "value_change_prefix",
	standalone: false
})
export class ValueChangePrefixPipe implements PipeTransform {
	public transform(value: string | number, args: ValueChangePrefixInterface): string {
		if (args.noChange) {
			return "" + value;
		}

		return (args.isProfit ? "+" : "-") + value;
	}
}

export interface ValueChangePrefixInterface {
	isProfit?: boolean; // When change occurs, we add + / -
	noChange?: boolean; // When no change occurs, the value remains nonformatted
}
